import { ObjectSource, ObjectSourceCategory } from "./types";
import {
  AdjustIcon,
  AdobeIcon,
  AdrollIcon,
  AirtableIcon,
  AmplitudeIcon,
  AsanaIcon,
  AwsCloudfrontIcon,
  AwsCloudTrailIcon,
  AwsDynamoDbIcon,
  AwsIcon,
  AwsInventoryIcon,
  AwsKinesisIcon,
  AwsLambdaIcon,
  AwsS3Icon,
  AzureEventHubIcon,
  AzureFunctionsIcon,
  AzureIcon,
  BranchIcon,
  CriteoIcon,
  DelightedIcon,
  DropboxIcon,
  FacebookIcon,
  FinancialForceIcon,
  FreshdeskIcon,
  FrontIcon,
  GithubIcon,
  GoogleAdsIcon,
  HubspotIcon,
  IntercomIcon,
  JiraIcon,
  KafkaIcon,
  MarketoIcon,
  OutreachIcon,
  PostgresqlIcon,
  SalesforceIcon,
  ShopifyIcon,
  SnapchatIcon,
  StripeIcon,
  SurveymonkeyIcon,
  TwilioIcon,
  YoutubeIcon,
  ZendeskIcon,
} from "../components/icons/themes/logos";
import { AppleLogoIcon } from "../components/icons/themes/color";
import { EmailIcon, FtpServerIcon } from "../components/icons/themes/windows10";

export const objectSources: Array<ObjectSource | ObjectSourceCategory> = [
  {
    fivetranService: "adjust",
    name: "Adjust",
    logo: AdjustIcon,
  },
  {
    fivetranService: "adobe_analytics",
    name: "Adobe Analytics",
    logo: AdobeIcon,
  },
  {
    fivetranService: "adroll",
    name: "Adroll",
    logo: AdrollIcon,
  },
  {
    fivetranService: "airtable",
    name: "Airtable",
    logo: AirtableIcon,
  },
  {
    fivetranService: "apache_kafka",
    name: "Apache Kafka",
    logo: KafkaIcon,
  },
  {
    fivetranService: "apple_search_ads",
    name: "Apple Search Ads",
    logo: AppleLogoIcon,
  },
  {
    fivetranService: "amplitude",
    name: "Amplitude",
    logo: AmplitudeIcon,
  },
  {
    fivetranService: "asana",
    name: "Asana",
    logo: AsanaIcon,
  },

  {
    name: "AWS S3",
    logo: AwsS3Icon,
    fivetranService: "s3",
  },
  {
    name: "AWS CloudTrail",
    logo: AwsCloudTrailIcon,
    fivetranService: "aws_cloudtrail",
  },
  {
    name: "AWS Inventory",
    logo: AwsInventoryIcon,
    fivetranService: "aws_inventory",
  },
  {
    name: "AWS Lambda",
    logo: AwsLambdaIcon,
    fivetranService: "aws_lambda",
  },
  {
    name: "AWS MSK",
    logo: AwsIcon,
    fivetranService: "aws_msk",
  },
  {
    name: "AWS DynamoDB",
    logo: AwsDynamoDbIcon,
    fivetranService: "dynamodb",
  },
  {
    name: "AWS CloudFront",
    logo: AwsCloudfrontIcon,
    fivetranService: "cloudfront",
  },
  {
    name: "AWS Kinesis",
    logo: AwsKinesisIcon,
    fivetranService: "kinesis",
  },

  {
    name: "Azure Blob Storage",
    logo: AzureIcon,
    fivetranService: "azure_blob_storage",
  },
  {
    name: "Azure Function",
    logo: AzureFunctionsIcon,
    fivetranService: "azure_function",
  },
  {
    name: "Azure Event Hub",
    logo: AzureEventHubIcon,
    fivetranService: "azure_event_hub",
  },

  {
    name: "Branch",
    fivetranService: "branch",
    logo: BranchIcon,
  },

  {
    name: "Criteo",
    fivetranService: "criteo",
    logo: CriteoIcon,
  },

  {
    name: "Delighted",
    fivetranService: "delighted",
    logo: DelightedIcon,
  },

  {
    name: "Dropbox",
    fivetranService: "dropbox",
    logo: DropboxIcon,
  },

  {
    name: "Email",
    fivetranService: "email",
    logo: EmailIcon,
  },

  {
    name: "Facebook",
    logo: FacebookIcon,
    items: [
      {
        name: "Facebook Ads",
        fivetranService: "facebook_ads",
      },
      {
        name: "Facebook Pages",
        fivetranService: "facebook_pages",
      },
    ],
  },

  {
    name: "Financial Force",
    fivetranService: "financial_force",
    logo: FinancialForceIcon,
  },

  {
    name: "Freshdesk",
    fivetranService: "freshdesk",
    logo: FreshdeskIcon,
  },

  {
    name: "Front",
    fivetranService: "front",
    logo: FrontIcon,
  },

  {
    name: "FTP",
    fivetranService: "ftp",
    logo: FtpServerIcon,
  },

  {
    name: "Github",
    fivetranService: "github",
    logo: GithubIcon,
  },

  {
    name: "Google Ad Manager",
    fivetranService: "double_click_publishers",
    logo: GoogleAdsIcon,
  },

  {
    name: "Hubspot",
    fivetranService: "hubspot",
    logo: HubspotIcon,
  },

  {
    fivetranService: "intercom",
    name: "Intercom",
    logo: IntercomIcon,
  },

  {
    name: "Jira",
    fivetranService: "jira",
    logo: JiraIcon,
  },

  {
    name: "Marketo",
    fivetranService: "marketo",
    logo: MarketoIcon,
  },

  {
    name: "Outreach",
    fivetranService: "outreach",
    logo: OutreachIcon,
  },

  {
    name: "QuickBooks",
    fivetranService: "quickbooks",
    logo: SalesforceIcon,
  },

  {
    name: "Shopify",
    fivetranService: "shopify",
    logo: ShopifyIcon,
  },

  {
    name: "SalesForce",
    fivetranService: "salesforce",
    logo: SalesforceIcon,
  },

  {
    name: "Stripe",
    fivetranService: "stripe",
    logo: StripeIcon,
  },

  {
    name: "Snapchat",
    fivetranService: "snapchat_ads",
    logo: SnapchatIcon,
  },

  {
    name: "Survey Monkey",
    fivetranService: "survey_monkey",
    logo: SurveymonkeyIcon,
  },

  {
    name: "Twilio",
    fivetranService: "twilio",
    logo: TwilioIcon,
  },

  {
    name: "Youtube Analytics",
    fivetranService: "youtube_analytics",
    logo: YoutubeIcon,
  },

  {
    name: "Zendesk",
    logo: ZendeskIcon,
    items: [
      {
        name: "Zendesk Support",
        fivetranService: "zendesk",
      },

      {
        name: "Zendesk Sunshine",
        fivetranService: "zendesk_sunshine",
      },

      {
        name: "Zendesk Chat",
        fivetranService: "zendesk_chat",
      },
    ],
  },

  // ... todo ...

  // {
  //   name: "Postgres",
  //   logo: PostgresqlIcon,
  //   items: [
  //     {
  //       name: "Aurora",
  //       description: "Hosted on Aurora",
  //       fivetranService: "aurora_postgres",
  //     },
  //     {
  //       name: "Azure",
  //       description: "Hosted on Azure",
  //       fivetranService: "azure_postgres",
  //     },
  //     {
  //       name: "Self-hosted",
  //       description: "Hosted by yourself",
  //       fivetranService: "postgres",
  //     },
  //     {
  //       name: "Google Cloud",
  //       description: "Hosted on Google Cloud",
  //       fivetranService: "google_cloud_postgresql",
  //     },
  //     {
  //       name: "Heroku",
  //       description: "Hosted on Heroku",
  //       fivetranService: "heroku_postgres",
  //     },
  //     {
  //       name: "RDS",
  //       description: "Hosted on RDS",
  //       fivetranService: "postgres_rds",
  //     },
  //   ],
  // },
];
